import { isValidNumber } from 'libphonenumber-js';
import * as Yup from 'yup';
import { URL_REGEX } from '../../../../../common/constants/validations';

const getMainFiledValidationSchema = () => {
  return Yup.object().shape({
    businessEmail: Yup.string()
      .email('Invalid Email')
      .required('Email Required'),
    companyName: Yup.string().trim().required('Company Name Required'),
    phoneNumber: Yup.string()
      .required('Phone Number Required')
      .when('$exist', {
        is: exist => exist,
        then: Yup.mixed().test(
          'is-phone-number',
          'Invalid Phone Number',
          value => {
            return isValidNumber(value);
          },
        ),
        otherwise: Yup.string(),
      }),
    companyWebsite: Yup.string()
      .matches(URL_REGEX, 'Invalid Url')
      .required('Company Website Required'),
    businessType: Yup.string().required('Please select an option'),
  });
};

const getValidationSchema = () => {
  return Yup.object().shape({
    businessEmail: Yup.string()
      .email('Invalid Email')
      .required('Email Required'),
    companyName: Yup.string().trim().required('Company Name Required'),
    phoneNumber: Yup.string().when('$exist', {
      is: exist => exist,
      then: Yup.mixed()
        .test('is-phone-number', 'Invalid Phone Number', value => {
          return isValidNumber(value);
        })
        .required('Phone Number Required'),
      otherwise: Yup.string(),
    }),
    companyWebsite: Yup.string()
      .matches(URL_REGEX, 'Invalid Url')
      .required('Company Website Required'),
    jobRole: Yup.string().required('Job Role Required'),
    clientsCharge: Yup.string().required('Deal Size Required'),
  });
};

export type UserInfoFormValues = {
  businessEmail: string;
  facebookAdSpend?: string;
  phoneNumber: string;
  companyWebsite: string;
  crm?: string;
  otherCrm?: string;
  employeeCount?: string;
  companyName: string;
  jobRole?: string;
  otherJobRole?: string;
  adBudget?: string;
  experienceWithChat?: string;
  goal?: string;
  otherGoal?: string;
  clientsCharge?: string;
  businessType?: string;
};

const fields = {
  businessEmail: 'businessEmail',
  companyName: 'companyName',
  companyWebsite: 'companyWebsite',
  phoneNumber: 'phoneNumber',
  facebookAdSpend: 'facebookAdSpend',
  crm: 'crm',
  otherCrm: 'otherCrm',
  employeeCount: 'employeeCount',
  jobRole: 'jobRole',
  otherJobRole: 'otherJobRole',
  adBudget: 'adBudget',
  experienceWithChat: 'experienceWithChat',
  goal: 'goal',
  otherGoal: 'otherGoal',
  clientsCharge: 'clientsCharge',
  businessType: 'businessType',
};

const defaultFormValues = (
  manualFacebookEmail?: string,
): UserInfoFormValues => {
  return {
    businessEmail: manualFacebookEmail || '',
    facebookAdSpend: '',
    phoneNumber: '',
    companyWebsite: '',
    companyName: '',
    crm: '',
    otherCrm: '',
    employeeCount: '',
    jobRole: '',
    otherJobRole: '',
    adBudget: '',
    experienceWithChat: '',
    goal: '',
    otherGoal: '',
    clientsCharge: '',
    businessType: '',
  };
};

export {
  fields,
  getValidationSchema,
  defaultFormValues,
  getMainFiledValidationSchema,
};
